(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["get-inspired"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Force first frame to show for asset videos
    document.querySelectorAll('.get-inspired__video--asset').forEach(function (v) {
      v.addEventListener('loadedmetadata', function () { v.currentTime = 0.001; });
      if (v.readyState >= 1) v.currentTime = 0.001;
    });

    document.querySelectorAll('.get-inspired').forEach(function (section) {
      var track = section.querySelector('.get-inspired__track');
      var prevBtn = section.querySelector('.get-inspired__arrow--prev');
      var nextBtn = section.querySelector('.get-inspired__arrow--next');
      if (!track || !prevBtn || !nextBtn) return;

      var current = 0;

      function visibleCount() {
        return window.innerWidth < 750 ? 1 : 4;
      }

      function cardWidth() {
        var card = track.querySelector('.get-inspired__card');
        if (!card) return 0;
        var gap = parseFloat(getComputedStyle(track).gap) || 12;
        return card.offsetWidth + gap;
      }

      function maxIndex() {
        var cards = track.querySelectorAll('.get-inspired__card');
        return Math.max(0, cards.length - visibleCount());
      }

      function update(animate) {
        if (window.innerWidth < 750) return;
        if (!animate) {
          track.style.transition = 'none';
          track.offsetHeight; // reflow
        }
        track.style.transform = 'translateX(-' + (current * cardWidth()) + 'px)';
        if (!animate) {
          track.offsetHeight;
          track.style.transition = '';
        }
        prevBtn.hidden = current <= 0;
        nextBtn.hidden = current >= maxIndex();
      }

      prevBtn.addEventListener('click', function () {
        current = Math.max(0, current - 1);
        update(true);
      });

      nextBtn.addEventListener('click', function () {
        current = Math.min(maxIndex(), current + 1);
        update(true);
      });

      window.addEventListener('resize', function () {
        current = Math.min(current, maxIndex());
        update(false);
      });

      update(false);

      section.querySelectorAll('.get-inspired__video').forEach(function (v) {
        v.muted = true;
      });

      section.querySelectorAll('.get-inspired__card').forEach(function (card) {
        card.addEventListener('click', function () {
          var inner = card.querySelector('.get-inspired__card-inner');
          var video = card.querySelector('.get-inspired__video');
          if (!video) return;

          var isPlaying = inner.classList.contains('is-playing');

          section.querySelectorAll('.get-inspired__card-inner').forEach(function (ci) {
            ci.classList.remove('is-playing');
            var v = ci.querySelector('.get-inspired__video');
            if (v) { v.pause(); v.currentTime = 0; v.muted = true; }
          });

          if (!isPlaying) {
            inner.classList.add('is-playing');
            video.muted = false;
            video.volume = 1;
            video.play();
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  (function() {
    function lockSlide(sw) {
      sw.setAttribute('disabled', 'true');
      sw.next = function() {};
      sw.previous = function() {};
    }
    function lockAll() {
      document.querySelectorAll('results-list slideshow-component').forEach(lockSlide);
    }
    if (window.customElements && window.customElements.whenDefined) {
      window.customElements.whenDefined('slideshow-component').then(function() {
        setTimeout(lockAll, 50);
      });
    }
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(lockAll, 200);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  // 3-square mini-gallery: tap opens the theme's own zoom-dialog fullscreen,
  // starting at the tapped image. Finds zoom-dialog by tag name (there's
  // only one on the page) and calls its real .open(index) method directly,
  // instead of a hardcoded on:click="#zoom-dialog-<id>/open/N" - that id
  // is theme-instance-specific (Shopify regenerates it per theme, not just
  // per push), so a hardcoded reference breaks the moment this template is
  // pushed to a different theme than the one it was read off of.
  document.addEventListener('DOMContentLoaded', function () {
    var squareButtons = document.querySelectorAll('[data-folliq-zoom-index]');
    if (!squareButtons.length) return;
    squareButtons.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        var dialog = document.querySelector('zoom-dialog');
        // .open() calls event.preventDefault() internally, so it needs a
        // real event object, not just the index - found the hard way when
        // dialog.open(index) alone threw "Cannot read properties of
        // undefined (reading 'preventDefault')".
        if (dialog && typeof dialog.open === 'function') {
          dialog.open(parseInt(btn.dataset.folliqZoomIndex, 10), event);
        }
      });
    });
  });

  // Text content fixes + "OFFER ENDS SOON" injection
  document.addEventListener('DOMContentLoaded', function () {
    var productInfo = document.querySelector('[data-testid="product-information"]');
    if (!productInfo) return;

    var isRosemary = window.location.pathname.indexOf('rosemary-batana-hair-oil') !== -1;

    // Replace customer count in rating text + restructure into non-breaking spans for clean wrap.
    // Matches on a class containing "text_stars" rather than the exact class
    // "text-block--text_stars": when this block's text setting has a locale
    // translation (e.g. German), Shopify renders it with a different,
    // translation-generated block id, so the class becomes
    // "text-block--<generatedid>__text_stars" instead. An exact-match selector
    // silently finds nothing on translated locales, leaving the untranslated/
    // stale static content visible instead of this rewritten version.
    var el = productInfo.querySelector('[class*="text_stars"] p');
    if (el) {
        var sBase = "white-space:nowrap;font-family:'Fraunces',Georgia,serif;font-weight:500;color:#4A2836;";
        var ratingFragment = document.getElementById('folliqRatingFragment');
        var ratingHtml = ratingFragment ? ratingFragment.innerHTML.trim() : '';
        var countFragment = document.getElementById('folliqRatingCustomerCount');
        var countHtml = countFragment ? countFragment.innerHTML.trim() : '';
        // Anchor line wraps onto its own row via flex-basis:100% - the
        // parent is already flex-wrap:wrap, so no layout change is needed
        // for the rating row itself.
        var anchorFragment = document.getElementById('folliqRatingAnchor');
        var anchorHtml = anchorFragment ? anchorFragment.innerHTML.trim() : '';
        el.innerHTML =
          '<span style="' + sBase + 'font-size:14px;">' + ratingHtml + '</span>' +
          '<span style="' + sBase + 'font-size:14px;margin-left:6px;">' + countHtml + '</span>' +
          (anchorHtml
            ? '<span style="flex-basis:100%;font-family:var(--font-body--family);font-size:12px;color:#6B6560;margin-top:4px;">' + anchorHtml + '</span>'
            : '');
        el.style.display = 'flex';
        el.style.flexWrap = 'wrap';
        el.style.justifyContent = 'flex-start';
        el.style.alignItems = 'center';
        el.style.gap = '0';
        el.style.padding = '6px 0 10px';
        el.classList.add('flq-rating-p');
        // Mark the immediate group-block container for full-width layout.
        // Gallery redesign (2026-08-13): rating is now nested one level
        // deeper (inside group_title_price), so this stops at the FIRST
        // group-block ancestor instead of continuing to the outermost one -
        // otherwise it would mark group_title_price itself instead of
        // group_rating's own wrapper, stretching/centering the whole
        // title+rating+squares+price cluster instead of just the rating row.
        var node = el.parentElement;
        var outerGroup = null;
        for (var d = 0; d < 8 && node; d++) {
          if (node.getAttribute && node.getAttribute('data-testid') === 'group-block') {
            outerGroup = node;
            break;
          }
          node = node.parentElement;
          if (node && node.getAttribute && node.getAttribute('data-testid') === 'product-details') break;
        }
        if (outerGroup) {
          outerGroup.classList.add('flq-rating-outer');
          outerGroup.style.width = '100%';
          outerGroup.style.alignSelf = 'stretch';
          outerGroup.style.justifyContent = 'flex-start';
        }
    }

    // Style urgency line as a Folliq urgency box.
    // Targets the fixed "text_urgency" block id instead of matching English "Almost Sold Out"/"Only" text.
    var el = productInfo.querySelector('.text-block--text_urgency p');
    if (el) {
        el.style.fontFamily = "'Work Sans', sans-serif";
        el.style.fontSize = '13px';
        el.style.fontWeight = '600';
        el.style.color = '#4A2836';
        el.style.whiteSpace = 'nowrap';
        var wrap = el.closest('.text-block');
        if (wrap) {
          wrap.style.display = 'flex';
          wrap.style.alignItems = 'center';
          wrap.style.justifyContent = 'center';
          wrap.style.gap = '6px';
          wrap.style.padding = '10px 14px';
          wrap.style.background = 'rgba(74,40,54,0.04)';
          wrap.style.border = '1px solid rgba(74,40,54,0.08)';
          wrap.style.borderRadius = '8px';
          wrap.style.marginBottom = '4px';
          wrap.classList.add('flq-urgency-wrap');
        }
    }

    // Style trust badge labels + container
    // DOM: .product-details > ... > .group-block(group_trust) > .group-block-content(container)
    //        > .group-block(trust_1) > .group-block-content(inner) > .icon-block + .text-block > p
    // Targets the fixed text_t1/text_t2/text_t3 block ids instead of matching English label text
    // (Guarantee/Shipping/Warranty/Returns/Support/Money), so this keeps working once labels are translated.
    var trustContainerFound = false;
    productInfo.querySelectorAll('.text-block--text_t1 p, .text-block--text_t2 p, .text-block--text_t3 p').forEach(function(el) {
      if (el.childElementCount === 0) {
          el.classList.add('flq-trust-label');
          el.style.fontFamily = "'Work Sans', sans-serif";
          el.style.fontSize = '11px';
          el.style.color = '#5A3A42';
          el.style.lineHeight = '1.4';
          el.style.textAlign = 'center';
          el.style.maxWidth = '88px';
          el.style.margin = '0';
          // innerContent = first group-block-content ancestor (flex column: icon + text)
          var innerContent = el.closest('[class*="group-block"]');
          // item = outer group-block for this trust badge (trust_1 / trust_2 / trust_3)
          var item = innerContent && innerContent.parentElement;
          if (item && item.classList.contains('group-block')) {
            // Guard: skip top-level blocks (outer product-details wrapper). Trust items are
            // always nested inside group_trust, so their parent must have a .group-block ancestor.
            if (!item.parentElement || !item.parentElement.closest('.group-block')) return;
            item.classList.add('flq-trust-item');
            // Style the SVG icon rose directly
            var svg = item.querySelector('svg');
            if (svg) {
              svg.style.color = '#C4748A';
              svg.querySelectorAll('path, circle, polyline, line, rect').forEach(function(p) {
                var f = p.getAttribute('fill');
                var s = p.getAttribute('stroke');
                if (f === 'none') {
                  p.style.stroke = '#C4748A';
                } else {
                  p.style.fill = '#C4748A';
                }
                if (s && s !== 'none') p.style.stroke = '#C4748A';
              });
            }
          }
          // container = shared parent holding all trust items (group-block-content of group_trust)
          if (!trustContainerFound && item && item.parentElement) {
            item.parentElement.classList.add('flq-trust-container');
            trustContainerFound = true;
          }
      }
    });

    // Accordion: JS backup styling (in case CSS cascade is overridden by compiled block CSS)
    productInfo.querySelectorAll('.accordion .details__header').forEach(function(el) {
      el.style.fontFamily = "'Fraunces', Georgia, serif";
      el.style.fontWeight = '500';
      el.style.fontSize = '15px';
      el.style.color = '#4A2836';
      el.style.display = 'flex';
      el.style.justifyContent = 'space-between';
      el.style.alignItems = 'center';
      el.style.padding = '18px 0';
      el.style.cursor = 'pointer';
      el.style.transition = 'color 0.2s ease';
      el.addEventListener('mouseenter', function() { el.style.color = '#C4748A'; });
      el.addEventListener('mouseleave', function() { el.style.color = '#4A2836'; });
    });
    productInfo.querySelectorAll('.accordion .details-content').forEach(function(el) {
      el.style.fontFamily = "'Work Sans', sans-serif";
      el.style.fontSize = '14px';
      el.style.lineHeight = '1.75';
      el.style.color = '#5A3A42';
      el.style.paddingBottom = '18px';
    });
    productInfo.querySelectorAll('.accordion .svg-wrapper.icon-plus').forEach(function(el) {
      el.style.width = '28px';
      el.style.height = '28px';
      el.style.minWidth = '28px';
      el.style.borderRadius = '50%';
      el.style.border = '1.5px solid #E7D9D0';
      el.style.background = 'transparent';
      el.style.display = 'flex';
      el.style.alignItems = 'center';
      el.style.justifyContent = 'center';
      el.style.flexShrink = '0';
      el.style.marginLeft = '12px';
      el.style.transition = 'background 0.2s ease, border-color 0.2s ease';
      var paths = el.querySelectorAll('path');
      paths.forEach(function(p) {
        p.setAttribute('stroke', '#C4748A');
        p.setAttribute('stroke-width', '2');
      });
    });

    // "OFFER ENDS SOON" + "fake variant box" injection removed 2026-08-11:
    // both were dark patterns (a countdown-style banner with no real
    // deadline, and a radio-button-styled plan selector with no <input> and
    // no click handler, on a single-variant product). The #folliqOfferData
    // bridge div that fed this (money-filter-formatted savings text, had no
    // other consumer) is removed too - see git history if either needs
    // resurrecting as something real.
  });

  // Reviews carousel
  document.addEventListener('DOMContentLoaded', function () {
    const reviewsSection = document.getElementById('shopify-section-reviews_section');
    if (!reviewsSection) return;

    const sectionContent = reviewsSection.querySelector('.section-content-wrapper');
    if (!sectionContent) return;

    const outerGroup = sectionContent.querySelector(':scope > .group-block');
    if (!outerGroup) return;

    const track = outerGroup.querySelector(':scope > .group-block-content');
    if (!track) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'reviews-carousel-wrapper';
    outerGroup.parentNode.insertBefore(wrapper, outerGroup);
    wrapper.appendChild(outerGroup);

    const prevBtn = document.createElement('button');
    prevBtn.className = 'reviews-carousel-btn reviews-carousel-btn--prev';
    prevBtn.setAttribute('aria-label', 'Previous reviews');
    prevBtn.innerHTML = '&#8592;';

    const nextBtn = document.createElement('button');
    nextBtn.className = 'reviews-carousel-btn reviews-carousel-btn--next';
    nextBtn.setAttribute('aria-label', 'Next reviews');
    nextBtn.innerHTML = '&#8594;';

    wrapper.appendChild(prevBtn);
    wrapper.appendChild(nextBtn);

    function getScrollAmount() {
      const firstCard = track.querySelector(':scope > .group-block');
      if (!firstCard) return 300;
      const gap = parseFloat(getComputedStyle(track).gap) || 16;
      return firstCard.offsetWidth + gap;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    function updateButtons() {
      prevBtn.style.display = track.scrollLeft <= 2 ? 'none' : 'flex';
      const atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      nextBtn.style.display = atEnd ? 'none' : 'flex';
    }

    track.addEventListener('scroll', updateButtons, { passive: true });
    updateButtons();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.vt-card__media').forEach(function (media) {
      var video = media.querySelector('.vt-card__video');
      if (!video) return;

      video.muted = true;
      video.addEventListener('loadedmetadata', function () { video.currentTime = 0.001; });
      if (video.readyState >= 1) video.currentTime = 0.001;

      media.addEventListener('click', function () {
        var playing = media.classList.contains('is-playing');
        document.querySelectorAll('.vt-card__media.is-playing').forEach(function (m) {
          m.classList.remove('is-playing');
          var v = m.querySelector('.vt-card__video');
          if (v) { v.pause(); v.muted = true; }
        });
        if (!playing) {
          media.classList.add('is-playing');
          video.muted = false;
          video.volume = 1;
          video.play();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
